<div fxLayoutAlign.gt-md="space-between center" fxLayout.lt-md="column">
  <h1>Aprovar plano de atividades</h1>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Período Letivo</mat-label>
      <mat-select [(value)]="anoSelecionado" (selectionChange)="getData()">
        <mat-option *ngFor="let ano of anos" [value]="ano">
          {{ ano }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<mat-form-field appearance="outline" fxFill>
  <mat-icon matPrefix>search</mat-icon>
  <mat-label>Pesquisar</mat-label>
  <input matInput type="search" (keyup)="search($event)" placeholder="" #input />
</mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
      <td mat-cell data-label="#" *matCellDef="let row">{{ row.id }}</td>
    </ng-container>
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aluno</th>
      <td mat-cell data-label="Aluno" *matCellDef="let row">{{ row.nome }}</td>
    </ng-container>
    <ng-container matColumnDef="programa">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Programa</th>
      <td mat-cell data-label="Programa" *matCellDef="let row">{{ row.programa }}</td>
    </ng-container>
    <ng-container matColumnDef="nomeDisciplina">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Disciplina</th>
      <td mat-cell data-label="Disciplina" *matCellDef="let row">{{ row.nomeDisciplina }}</td>
    </ng-container>
    <ng-container matColumnDef="codigoDisciplina">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
      <td mat-cell data-label="Código" *matCellDef="let row">{{ row.codigoDisciplina }}</td>
    </ng-container>
    <ng-container matColumnDef="semestre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Semestre</th>
      <td mat-cell data-label="Semestre" *matCellDef="let row">{{ row.semestre }}</td>
    </ng-container>
    <ng-container matColumnDef="situacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
      <td mat-cell data-label="Situaçaõ" *matCellDef="let row">{{ row.situacao }}</td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <span *ngIf="isChefeDepartamento()">Analisar</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <button
          *ngIf="isChefeDepartamento()"
          mat-icon-button
          routerLink="/departamento/aprovar-plano/{{ row.id }}"
          title="Analisar">
          <mat-icon>troubleshoot</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
    <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="8">
        <span *ngIf="input.value">Nenhum registro encontrado para a pesquisa: "{{ input.value }}"</span>
        <span *ngIf="!input.value">Nenhum registro disponível</span>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
</div>
